import store from '@/store/index.js'
let dic = store.state.dic;
import moment from "moment";

export default function Configs(that) {

    const searchItems = [
        {
            label: "名称",
            span: 8,
            placeholder: '请输入名称',
            model: "name"
        },
    ]
    const tableColumns = [
        {
            label: "事项名称",
            prop: "name",
            align: "center",
            minWidth: 100,
            show: true
        },
        {
            label: "开始时间",
            prop: "startTime",
            align: "center",
            minWidth: 150,
            show: true
        },
        {
            label: "结束时间",
            prop: "endTime",
            align: "center",
            minWidth: 150,
            show: true,
        },
        {
            label: "开放类型",
            prop: "academicDegreeName",
            align: "center",
            minWidth: 160,
            show: true
        },
        {
            label: "排序",
            prop: "sort",
            align: "center",
            show: true
        },
        {
            label: "状态",
            prop: "isOpen",
            align: "center",
            show: true,
            formatter: (row) => {
                return row.isOpen == 1 ? '启用' : '禁用'
            }
        },
        {
            label: "操作",
            name: "contr",
            align: "center",
            width: '80px',
            show: true
        }
    ]
    const formItems = [
        {
            label: "事项名称",
            span: 24,
            model: "name",
            disabled: true,
            labelClass: 'info-label',
        },
        {
            label: "开始时间",
            span: 24,
            model: "startTime",
            type: 'datetime',
            placeholder: '请选择开始时间',
            labelClass: 'info-label',
            pickerOptions: {
                disabledDate(time) {
                    let time1 = new Date(that.handleData.endTime).getTime();
                    return time.getTime() > time1
                }
            },
        },
        {
            label: "结束时间",
            span: 24,
            model: "endTime",
            type: 'datetime',
            placeholder: '请选择结束时间',
            labelClass: 'info-label',
            pickerOptions: {
                disabledDate(time) {
                    let minTime = moment(that.handleData.startTime).format('HH:mm:ss');
                    let oneDay = 24 * 60 * 60 * 1000;
                    let time1 = new Date(that.handleData.startTime).getTime()
                    if (minTime != '00:00:00') {
                        time1 = time1 - oneDay;
                    }
                    return time.getTime() < time1
                }
            },
        },
        {
            label: "开放类型",
            span: 24,
            model: "academicDegree",
            type: 'select',
            multiple: true,
            options: dic._ACADEMICDEGREE,
        },
        {
            label: "是否启用",
            span: 24,
            model: "isOpen",
            type: 'radio',
            options: dic._IS,
        },
    ]

    const formRules = {
        startTime: [{
            required: true,
            trigger: "blur",
            message: '请选择开始时间'
        }],
        endTime: [{
            required: true,
            trigger: "blur",
            message: '请选择结束时间'
        }],
        academicDegree: [{
            required: true,
            trigger: "blur",
            message: '请选择'
        }],
        isOpen: [{
            required: true,
            trigger: "blur",
            message: '请选择'
        }],
    }
    return {
        searchItems,
        tableColumns,
        formItems,
        formRules
    }
}
